import { RGBAColor } from "core/math";
export class ColorResolver {
    constructor(defaultColor, colorMap) {
        this.defaultColor = defaultColor;
        this.colorMap = colorMap;
    }
    getColor(key) {
        let v = this.colorMap.get(key);
        if (v) {
            switch (v[0]) {
                case "#":
                    return RGBAColor.Parse(v);
                case "@":
                    return this.getColor(v.substring(1));
                default:
                    return new RGBAColor(RGBAColor.CSSMap.get(v) ?? this.defaultColor);
            }
        }
        return new RGBAColor(this.defaultColor);
    }
}
//# sourceMappingURL=osm.colorResolver.js.map